import { uiSize } from '@utils'

interface Props {
  color?: string
}

function UploadArrowIcon({ color = 'currentColor' }: Props) {
  return (
    <svg
      width={uiSize(14)}
      height={uiSize(14)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M12 19V5M5 12l7-7 7 7' />
    </svg>
  )
}

export default UploadArrowIcon
